import { WistiaPlayer } from "@wistia/wistia-player";

import { LangstonContentResponse } from "@/types/models";
import { GenerationGeniusAPIResponse } from "@/types/models/GenerationGenius.interface";

export interface WistiaPlayerCustomEvent {
  target: WistiaPlayer;
}

export interface IUnlevelledContent
  extends Omit<LangstonContentResponse, "data"> {
  data: GenerationGeniusAPIResponse | CommonIFrameData;
}

export interface GenerationGeniusContent
  extends Omit<LangstonContentResponse, "data"> {
  data: GenerationGeniusAPIResponse;
}

export interface GeniusAttachment {
  id: string;
  created_date: string;
  modified_date: string;
  checksum: string;
  content_type: string;
  data: {
    url: string;
    name: string;
    label: string;
    author: string;
    status: string;
    link_cta: string;
    image_url: string | null;
    thumbnail: string | null;
    link_title: string;
    updated_at: string;
    content_type: string;
    estimated_time: string | null;
    maturity_range: number[];
    link_description: string | null;
  };
  is_visible: boolean;
}

export interface GeniusAttachmentResponse {
  attachments?: GeniusAttachment[] | null | undefined;
}

export enum VideoSubject {
  LANGUAGE_ARTS = "Language Arts",
  MATHEMATICS = "Mathematics",
  SCIENCE = "Science",
}

export interface CommonIFrameData {
  content_type: "PHET_SIMULATION";
  is_lite: boolean;
  is_premium: boolean;
  date_lite_product_grant_expires?: string | null;
  pdfs: string;
  discussion_questions?: string;
  vocabulary?: string;
  url: string;
  label: string;
  name: string;
  author: string;
  status: string;
  link_cta: string;
  image_url: string | null;
  thumbnail: string | null;
  link_title: string;
  updated_at: string;
  estimated_time: string | null;
  maturity_range: number[];
  link_description: string | null;
  title: string;
}
